import styled from 'styled-components';

export const DraftContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  padding: 20px;
  gap: 24px;
  overflow-y: auto;
`;
